import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["data", "defaultRowData", "shouldAddDefaultRow"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import _size from 'lodash/size';
import { defaultMemoize } from 'reselect';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
export default function withDefaultRow(TableComponent) {
  var _class;
  return _class = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(withDefaultRowComponent, _React$PureComponent);
    var _super = _createSuper(withDefaultRowComponent);
    function withDefaultRowComponent() {
      var _this;
      _classCallCheck(this, withDefaultRowComponent);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "getUpdatedData", defaultMemoize(function (data, defaultRowData, shouldAddDefaultRow) {
        return shouldAddDefaultRow ? [].concat(_toConsumableArray(data), [defaultRowData]) : data;
      }));
      return _this;
    }
    _createClass(withDefaultRowComponent, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          data = _this$props.data,
          defaultRowData = _this$props.defaultRowData,
          shouldAddDefaultRow = _this$props.shouldAddDefaultRow,
          tableProps = _objectWithoutProperties(_this$props, _excluded);
        var updatedData = this.getUpdatedData(data, defaultRowData, shouldAddDefaultRow);
        return /*#__PURE__*/React.createElement(TableComponent, _extends({}, tableProps, {
          data: updatedData,
          pageSize: _size(updatedData)
        }));
      }
    }]);
    return withDefaultRowComponent;
  }(React.PureComponent), _defineProperty(_class, "propTypes", {
    defaultRowData: PropTypes.object.isRequired,
    data: PropTypes.array,
    shouldAddDefaultRow: PropTypes.bool
  }), _defineProperty(_class, "defaultProps", {
    data: EMPTY_ARRAY,
    shouldAddDefaultRow: false
  }), _class;
}